module.exports = __webpack_public_path__ + "media/images/icon-product/label-a6f86c86beab1b653413d0188dc5fb26.svg";